import { createAsyncCategoryHandler } from "../category-dispatcher";
import { datasourceTools } from "./datasource-tools";
import { fileTools } from "./file-tools";
import { navigationTools } from "./navigation-tools";
import { projectTools } from "./project-tools";
import { roleTools } from "./role-tools";
import { screenManagementTools } from "./screen-management-tools";
import { viewportTools } from "./viewport-tools";

/**
 * Category handler for project-level operations.
 * Consolidates project-tools, screen-management-tools, datasource-tools,
 * navigation-tools, viewport-tools, and file-tools handlers.
 */
export const handleProjectCategory = createAsyncCategoryHandler(
  {
    get_current_view: navigationTools.sync!.ui_common_get_current_view,
    set_left_panel: navigationTools.sync!.ui_project_set_left_panel,
    set_right_panel: navigationTools.sync!.ui_project_set_right_panel,
    list_datasources: datasourceTools.sync!.ui_project_list_datasources,
    get_datasource_actions: datasourceTools.sync!.ui_project_get_datasource_actions,
    query_datasource_actions: datasourceTools.sync!.ui_project_query_datasource_actions,
    list_devices: viewportTools.sync!.ui_project_list_devices,
    get_current_device: viewportTools.sync!.ui_project_get_current_device,
    set_device: viewportTools.sync!.ui_project_set_device,
    list_roles: roleTools.sync!.ui_project_list_roles,
    get_screen_authorization: roleTools.sync!.ui_project_get_screen_authorization,
    set_screen_authorization: roleTools.sync!.ui_project_set_screen_authorization
  },
  {
    // KOA-18448 — the role mutations moved to the AWAITED half with their handlers. The
    // non-null assertions above cannot catch this move (the groups are index signatures, so a
    // missing key types as a handler and fails only at runtime), which is exactly why the pair
    // has to be changed together.
    create_role: roleTools.async!.ui_project_create_role,
    update_role: roleTools.async!.ui_project_update_role,
    delete_role: roleTools.async!.ui_project_delete_role,
    set_screen_role: roleTools.async!.ui_project_set_screen_role,
    save: projectTools.async!.ui_common_save_screen,
    reload_screen: screenManagementTools.async!.ui_common_reload_screen,
    reload_datasources: datasourceTools.async!.ui_common_reload_datasources,
    preview: projectTools.async!.ui_run_preview,
    navigate_to_view: navigationTools.async!.ui_project_navigate_to_view,
    navigate_to_datasource: datasourceTools.async!.ui_project_navigate_to_datasource,
    export_translations: fileTools.async!.ui_common_export_translations,
    export_excel_template: fileTools.async!.ui_common_export_excel_template,
    reload_project: projectTools.async!.ui_common_reload_project
  }
);
